"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TouristLicence = exports.DEFAULT_LICENCE_ALIASES = void 0;
const React = __importStar(require("react"));
const FormInput_1 = require("../../../../components/input/text/FormInput");
const Spacer_1 = require("../../../../components/spacer/Spacer");
const local_licence_1 = require("../../../../../hooks/validation/local-licence");
exports.DEFAULT_LICENCE_ALIASES = {
    number: 'Local licence number',
    identification_number: 'Tax ID number'
};
const TouristLicence = (props) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const { property, update, requirements } = props;
    const localLicence = (property.local_licence || {});
    const [numberValid, numberErrMsg] = (0, local_licence_1.useLocalLicenceValidation)('number', property);
    const [taxIdValid, taxIdErrMsg] = (0, local_licence_1.useLocalLicenceValidation)('identification_number', property);
    return (React.createElement("div", { role: "group", "aria-labelledby": "tourist-licence-header" },
        ((_a = requirements.fields) === null || _a === void 0 ? void 0 : _a.number) && (React.createElement(React.Fragment, null,
            React.createElement(Spacer_1.Spacer, null),
            React.createElement(FormInput_1.FormInput, { label: (_c = (_b = requirements === null || requirements === void 0 ? void 0 : requirements.fieldAliases) === null || _b === void 0 ? void 0 : _b.number) !== null && _c !== void 0 ? _c : exports.DEFAULT_LICENCE_ALIASES.number, id: "local-licence-number-input", value: localLicence.number, onChange: (e) => update({ local_licence: Object.assign(Object.assign({}, localLicence), { number: e.target.value }) }), valid: numberValid, errorMessage: numberErrMsg, hintText: (_d = requirements === null || requirements === void 0 ? void 0 : requirements.fieldExplanations) === null || _d === void 0 ? void 0 : _d.number }))),
        ((_e = requirements.fields) === null || _e === void 0 ? void 0 : _e.identification_number) && (React.createElement(React.Fragment, null,
            React.createElement(Spacer_1.Spacer, null),
            React.createElement(FormInput_1.FormInput, { label: (_g = (_f = requirements === null || requirements === void 0 ? void 0 : requirements.fieldAliases) === null || _f === void 0 ? void 0 : _f.identification_number) !== null && _g !== void 0 ? _g : exports.DEFAULT_LICENCE_ALIASES.identification_number, id: "tax-id-number-input", value: localLicence.identification_number, onChange: (e) => update({ local_licence: Object.assign(Object.assign({}, localLicence), { identification_number: e.target.value }) }), valid: taxIdValid, errorMessage: taxIdErrMsg, hintText: (_h = requirements === null || requirements === void 0 ? void 0 : requirements.fieldExplanations) === null || _h === void 0 ? void 0 : _h.identification_number })))));
};
exports.TouristLicence = TouristLicence;
//# sourceMappingURL=TouristLicence.js.map